<template>
  <div>
    <v-data-table
      colspan="100%"
      :headers="headers"
      :items="items"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
    >
      <template v-slot:no-data>
        Sem dados
      </template>
      <template #[`item.nome`]="{ item }">
        <v-list-item
          class="ml-n4"
          @click="editPausa(item)"
        >
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold
                `"
              >
                {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
              </span>
            </v-avatar>
            <div class="d-flex flex-column ms-3">
              {{ item.nome }}
            </div>
          </div>
        </v-list-item>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo === true ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo === true ? 'success' : 'secondary'}`"
        >
          {{ item.ativo === true ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
            >
              <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                role="button"
                @click="deleteItem(item)"
              >
                <v-icon
                  size="20"
                  class="me-2"
                  small
                >
                  {{ icons.mdiDelete }}
                </v-icon>
                <span>{{ item.ativo === true ? 'Inativar' : 'Ativar' }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          {{ inativar.ativo === true ? 'Inativar' : 'Ativar' }} Pausa
        </v-card-title>
        <v-card-text>
          Tem certeza que deseja {{ inativar.ativo === true ? 'Inativar' : 'Ativar' }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDelete"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarInativacao"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <edit-pausa-dialog
      :edit="edit"
      :data="data"
      :open-add-pausas.sync="openAddPausas"
      @refetch-data="$emit('refetch-data')"
    />
  </div>
</template>

<script>
import { mdiDelete, mdiDotsVertical } from '@mdi/js'
import EditPausaDialog from '@/views/pausas/EditPausaDialog.vue'
import PausasService from '@/services/modules/PausasService'

export default {
  components: {
    EditPausaDialog,
  },
  props: {
    items: {
      type: Array,
      default: () => { },
    },
    headers: {
      type: Array,
      default: () => { },
    },
  },
  setup() { },

  data: () => ({
    dialogDelete: false,
    openAddPausas: false,
    dialogInativar: false,
    ativarInaticar: false,
    edit: true,
    data: null,
    loading: false,
    icons: {
      mdiDelete,
      mdiDotsVertical,
    },
    id: '',
    inativar: {
      nome: '',
      descricao: '',
      tempo: '',
    },
  }),

  watch: {
    openAddPausas() {
      if (!this.openAddPausas) {
        this.edit = false
        this.data = {
          nome: '',
          descricao: '',
          tempo: '',
        }
      }
    },
  },

  methods: {
    async confirmarInativacao() {
      this.loading = true
      this.ativarInaticar = !this.inativar.ativo

      try {
        await PausasService.ativarOuInativarPausa(this.inativar.id, {
          ativar: this.ativarInaticar,
        })

        this.closeDelete()
        this.$emit('confirmar-inativacao')
        this.loading = false
      } catch {
        this.closeDelete()
        this.loading = false
      }
    },

    atualizar() {
      this.dialogDelete = false
      this.dialogInativar = true
    },

    InativarMsg() {
      this.dialogDelete = false
    },

    // this.dialogInativar = false
    deleteItem(item) {
      this.inativar = item
      this.dialogDelete = true
    },

    editItem(item) {
      this.inativar = item
      this.dialogDelete = true
    },

    closeDelete() {
      this.dialogDelete = false
    },

    editPausa(item) {
      this.edit = true
      this.data = item

      if (this.data.tempo) {
        const isFormatted = /^\d{2}:\d{2}$/.test(this.data.tempo)

        if (!isFormatted) {
          let cleanedValue = this.data.tempo.toString().replace(/\D/g, '')
          cleanedValue = cleanedValue.padStart(4, '0')
          const totalMinutes = parseInt(cleanedValue, 10)

          if (totalMinutes <= 1439) {
            const hours = Math.floor(totalMinutes / 60)
            const minutes = totalMinutes % 60

            const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
            this.data.tempo = formattedTime
          } else {
            this.data.tempo = ''
          }
        }
      } else {
        this.data.tempo = ''
      }

      this.openAddPausas = true
    },

  },
}
</script>
